import React from "react";
import { SectionIndicator } from "../sectionIndicator/SectionIndicator";
import { Colors } from "../../utils/colors";
import { TCText } from "../TCText/TCText";

type props = {};

export const PaymentInitial: React.FC<props> = () => {
  return (
    <div
      style={{
        backgroundColor: "white",
        borderRadius: 20,
        paddingLeft: 20,
        paddingRight: 20,
        paddingBottom: 20,
        paddingTop: 20,
        marginTop: 20,
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        gap: 20,
      }}>
      <SectionIndicator number="3" color={Colors.green} />
      <TCText
        style={{ color: "black", fontWeight: 600, fontSize: 14 }}
        value="Payment summary"
      />
    </div>
  );
};
